class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItem = this.closest('.cart-item');
      const variantId = Number(cartItem?.getAttribute('data-var-id'));
      const cartItems =
      this.closest("cart-items") || this.closest("cart-drawer-items");
      if (cartItem) {
        setTimeout(() => {
          cartItem.classList.add('cart-item--removing');
        }, 40);
      }

      let giftIds = [];
      try {
        giftIds = JSON.parse(sessionStorage.getItem('FREE_GIFT_ADDED_IDS')) || [];
      } catch {
        giftIds = [];
      }

      if (giftIds.includes(variantId)) {
        sessionStorage.setItem('FREE_GIFT_SUPPRESS_ONCE', 'true');
      }

      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);


//  function freepdpdetails() {
//    freeshippingArr.forEach((freeProduct) => {
//     let variantId = freeProduct.freePdp; 
//     document.querySelectorAll(".cart-item").forEach(item => {
//         let itemVariantId = item.getAttribute("data-var-id");
//         if (itemVariantId == variantId) {
//             let quantityWrapper = item.querySelector(".cart-item__quantity-wrapper");
//             let price = item.querySelector(".cart-item__final-price"); 
//             let cartdetails = item.querySelector(".cart-item__inner-top"); 
//             if (quantityWrapper) {
//                 quantityWrapper.style.display = "none"; 
              
//                 // Check if span.freepdp already exists to prevent duplicate elements
//                 if (!item.querySelector(".freepdp")) {
//                     let freePdpSpan = document.createElement("span");
//                     freePdpSpan.classList.add("freepdp");
//                     freePdpSpan.textContent = "FREE GIFT!";
//                     quantityWrapper.insertAdjacentElement("afterend", freePdpSpan);
//                 }
//               let style = document.createElement("style");
//                 style.innerHTML = `
//                     span.freepdp {
//                         margin-top: 10px;
//                         font-weight: 600;
//                         color: #ffa522;
//                     }
//                 `;
//                 document.head.appendChild(style);
//             }
//             if (price) {
//                 price.style.display = "none"; 
//             }
//             if (cartdetails) {
//                 cartdetails.style.alignItems = "center";
//             }
//         }
//     });
//   });
// }

function isProductInCart(variantId) {
  const miniCartItems = document.querySelectorAll('.cart-item');
  let isProductInCart = false;
  
  miniCartItems.forEach(item => {
      const varid = item.getAttribute('data-var-id');
      if (varid == variantId) {
          isProductInCart = true;
      }
  });
  
  return isProductInCart;
}

function addToCart(variantId, quantity = 1, sellingPlanId = null) {
  const sections = ['cart-drawer', 'cart-icon-bubble'];
  const data = { 
    id: variantId, 
    quantity, 
    sections 
  };
  if (sellingPlanId) data.selling_plan = sellingPlanId;

  return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then((responseText) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.renderContents(responseText);
    // console.log("Product added to cart.");
    // Debounced free gift handling to prevent rapid successive calls
    debounceFreeGiftHandler();
    return responseText;
  })
  .catch(error => {
    console.error('Error adding product:', error);
    throw error;
  });
}

// Debounced free gift handler to prevent rapid successive calls
let freeGiftDebounceTimeout;
function debounceFreeGiftHandler() {
  clearTimeout(freeGiftDebounceTimeout);
  freeGiftDebounceTimeout = setTimeout(() => {
    freeGiftHandler.handleFreeGift();
  }, 100);
}

function setButtonLoadingState(button, isLoading) {
  const loadingIcon = button.querySelector('.icon-loading');
  button.disabled = isLoading;
  button.classList.toggle('loading', isLoading);
  if (loadingIcon) loadingIcon.classList.toggle('hidden', !isLoading);
}

function handleFreeShippingProduct() {
  if (freeshippingArr.length === 0) {
    //  console.log('No free shipping products available.');
    return;
  }

  // let freeProduct = freeshippingArr[0]; 
  // let variantId = freeProduct.freePdp; 
  // let freeProductPrice = freeProduct.vprice; 

  freeshippingArr.forEach((freeProduct) => {
    let variantId = freeProduct.freePdp;
    let freeProductPrice = freeProduct.vprice;
    let subtotalElement = document.getElementById("mini-cart-subtotal");  
    let cartSubtotal = parseFloat(subtotalElement.getAttribute("data-subtotal"));
    let sections = ['cart-drawer', 'cart-icon-bubble'];
    let freeProductElement = document.querySelector(`.cart-item[data-var-id="${variantId}"]`);

  if (cartSubtotal >= freeProductPrice && !freeProductElement) {
    // Add the free product
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sections
      }),
    })
    .then(response => response.json())
    .then((responseText) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.renderContents(responseText);
      }
      console.log("Free product added.");
    })
    .catch(error => console.error('Error adding free product:', error));
  } 
  else if (cartSubtotal < freeProductPrice && freeProductElement) {
    // Remove the free product
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        updates: { [variantId]: 0 }, // Remove Product
        sections: sections
      })
    })
    .then(response => response.json())
    .then((responseText) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.renderContents(responseText);
      }
      
      console.log("Free product removed.");
    })
    .catch(error => console.error('Error removing product:', error));
  } 
  else {
    //console.log("No action needed.");
  }
  });
}
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
    handleFreeShippingProduct();
    debounceFreeGiftHandler();
    // freepdpdetails();

    // Cart Parcel Protection
    handleParcelProtectionButtons();
    checkParcelProtectionState();   
  }
  
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const sourceQty = html.querySelector("cart-items");
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    const progressLine = document.querySelector('.cart-progress-bar__line');
    const currentProgress = progressLine ? getComputedStyle(progressLine).getPropertyValue('--line-progress').trim() : '0%';

    this.enableLoading(line);
    this.querySelectorAll(".quantity__button").forEach((button) =>
      button.classList.add("disabled")
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      const parsedState = JSON.parse(state);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll(".cart-item");
      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute("value");
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      this.classList.toggle("is-empty", parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector("cart-drawer");
      const cartFooter = document.getElementById("main-cart-footer");

      if (cartFooter)
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      if (cartDrawerWrapper)
        cartDrawerWrapper.classList.toggle(
          "is-empty",
          parsedState.item_count === 0
        );

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document
            .getElementById(section.id)
            .querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
      const updatedValue = parsedState.items[line - 1]
        ? parsedState.items[line - 1].quantity
        : undefined;
      let message = "";
      if (
        items.length === parsedState.items.length &&
        updatedValue !== parseInt(quantityElement.value)
      ) {
        if (typeof updatedValue === "undefined") {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace(
            "[quantity]",
            updatedValue
          );
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`)
            )
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper.querySelector(".drawer__inner-empty"),
          cartDrawerWrapper.querySelector("a")
        );
      } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper,
          document.querySelector(".cart-item__name")
        );
      }
      publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
      debounceFreeGiftHandler();
      animateProgressBar(currentProgress);
    })
    .catch(() => {
      this.querySelectorAll(".loading-overlay").forEach((overlay) =>
        overlay.classList.add("hidden")
      );
      this.querySelectorAll(".quantity__button").forEach((button) =>
        button.classList.remove("disabled")
      );
      const errors =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      this.querySelectorAll(".quantity__button").forEach((button) =>
        button.classList.remove("disabled")
      );
      this.disableLoading(line);
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
    
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
class CartItemUpgradeButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleUpgrade.bind(this));
  }

  async handleUpgrade(event) {
    const button = event.target.closest('button');
    if (!button) return;
      
    event.preventDefault();
    
    const { itemKey, cartFirstSellingPlanId: sellingPlanId, nextVariantId } = this.dataset;    
    if (!itemKey || !nextVariantId) {
      console.error('Cart item upgrade: Missing required data');
      return;
    }

    setButtonLoadingState(button, true);

    try {
      const currentQuantity = this.getCurrentItemQuantity();
      const urlRoot = window.Shopify?.routes?.root || '/';

      // Use cart/change.js to replace the item in one API call
      const changeData = {
        id: itemKey,
        quantity: 0, 
        sections: ['cart-drawer', 'cart-icon-bubble']
      };

      // First remove the current item
      const removeResponse = await fetch(`${urlRoot}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(changeData)
      });

      if (!removeResponse.ok) throw new Error(`Remove failed: ${removeResponse.status}`);
      await removeResponse.json();

      // Then add the new variant
      const result = await addToCart(nextVariantId, currentQuantity, sellingPlanId);
      this.updateCartDrawer(result);
    
    } catch (error) {
      console.error('Cart item upgrade failed:', error);
      this.showErrorMessage(button, 'Failed to upgrade item. Please try again.');
    } finally {
      setButtonLoadingState(button, false);
    }
  }

  getCurrentItemQuantity() {
    const quantityInput = this.closest('.cart-item')?.querySelector('input[name="updates[]"]');
    return parseInt(quantityInput?.value, 10) || 1;
  }

  updateCartDrawer(cartData) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.renderContents) cartDrawer.renderContents(cartData);

    if (window.PUB_SUB_EVENTS?.cartUpdate && typeof publish === 'function') {
      publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-item-upgrade-button' });
    }
  }

  showErrorMessage(button, message) {
    let errorElement = this.querySelector('.upgrade-error');
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.className = 'upgrade-error cart-item__error';
      this.appendChild(errorElement);
    }
    errorElement.innerHTML = `<small class="cart-item__error-text">${message}</small>`;
    clearTimeout(this.errorTimeout);
    this.errorTimeout = setTimeout(() => errorElement.remove(), 5000);
  }
}
customElements.define('cart-item-upgrade-button', CartItemUpgradeButton);

// Free Gift Handler Class 
class FreeGiftHandler {
  constructor() {
    this.sessionStorageKey = 'FREE_GIFT_ADDED_IDS';
    this.isProcessing = false; // Execution guard to prevent concurrent calls
    this.processingPromise = null; // Track ongoing processing
  }

  async getCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }
  
  async handleFreeGift() {
    if (this.isProcessing) {
      return this.processingPromise;
    }
  
    this.isProcessing = true;
  
    // Run the processing and ensure guard is reset even if it throws
    this.processingPromise = (async () => {
      try {
        // One-shot suppression to avoid immediate re-add after manual removal
        if (sessionStorage.getItem('FREE_GIFT_SUPPRESS_ONCE') === 'true') {
          sessionStorage.removeItem('FREE_GIFT_SUPPRESS_ONCE');
          return; 
        }

        // Sync sessionStorage with current cart so manual removals are respected
        // and we only track what’s actually in the cart right now.
        const cart = await this.getCart();
        if (cart && Array.isArray(cart.items)) {
          const giftIdsInCart = cart.items
            .filter(item => item && item.properties && item.properties['_FREE_GIFT_ADDED'] === true)
            .map(item => item.variant_id)
            .filter(id => typeof id === 'number' && id > 0);  
          sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(giftIdsInCart));
        }
  
        await this.processFreeGifts();
      } catch (error) {
        console.error('FreeGiftHandler.handleFreeGift error:', error);
      } finally {
        this.isProcessing = false;
        this.processingPromise = null;
      }
    })();
  
    return this.processingPromise;
  }

  async processFreeGifts() {
    const cart = await this.getCart();
    const tiers = document.querySelectorAll('[data-tier-variant-id]');

    if (!cart || !tiers.length) return;

    const variantIds = [];
    const lineItemKeys = [];

    // Get the total price of the cart, excluding free gifts
    const totalPrice = cart.items.reduce((acc, item) => {
      if (!item.properties || item.properties['_FREE_GIFT_ADDED'] !== true) {
        return acc + item.final_line_price;
      }
      return acc;
    }, 0);


    // Process all qualifying tiers
    tiers.forEach((tier) => {
      const variantId = Number(tier.getAttribute('data-tier-variant-id'));
      const tierAmount = Number(tier.getAttribute('data-tier-amount'));

      if (!Number.isFinite(variantId) || !Number.isFinite(tierAmount)) {
        return;
      }

      const giftAlreadyAdded = cart.items.find(
        (item) => item.variant_id === variantId && item.properties && item.properties['_FREE_GIFT_ADDED']
      );

      if (giftAlreadyAdded) {
        if (tierAmount > totalPrice) {
          lineItemKeys.push(giftAlreadyAdded.key);
        }
      } else {
        if (totalPrice >= tierAmount) {
          variantIds.push(variantId);
        }
      }
    });

    // First remove any gifts that no longer qualify
    if (lineItemKeys.length > 0) {
      await this.removeFreeGift(lineItemKeys);
    }

    // Then add any new qualifying gifts
    if (variantIds.length > 0) {
      await this.addFreeGift(variantIds);
    }
  }

  async addFreeGift(variantIds) {
    if (!variantIds || variantIds.length === 0) return;
    
    const freeGiftAdded = JSON.parse(sessionStorage.getItem(this.sessionStorageKey)) || [];
    const newVariantIds = variantIds.filter(variantId => !freeGiftAdded.includes(variantId));
    if (newVariantIds.length === 0) return;

    const cartItemList = document.querySelector('#CartDrawer-CartItems');
    this.toggleLoadingOverlay(cartItemList, true);

    try {
      const items = newVariantIds.map((variantId) => {
        return {
          id: variantId,
          quantity: 1,
          properties: {
            _FREE_GIFT_ADDED: true,
          },
        };
      });

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        body: JSON.stringify({
          items,
          sections: ['cart-drawer', 'cart-icon-bubble']
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (response.ok) {
        // Update session storage with newly added variant IDs
        const updatedFreeGiftAdded = [...freeGiftAdded, ...newVariantIds];
        sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(updatedFreeGiftAdded));
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.renderContents(await response.json());

          // Use requestAnimationFrame for better DOM synchronization
          requestAnimationFrame(() => {
            newVariantIds.forEach(variantId => {
              const newCartItem = document.querySelector(`[data-var-id="${variantId}"]`);
              if (newCartItem) {
                newCartItem.classList.add('free-gift-item--adding');
              }
            });
          });
        }
      }
    } catch (error) {
      console.error('Error adding free gift:', error);
    }
  }

  async removeFreeGift(keys) {
    if (!keys || keys.length === 0) return;

    const freeGiftIds = keys.map((key) => {
      return Number(key.split(':')[0]);
    });

    const freeGiftAdded = JSON.parse(sessionStorage.getItem(this.sessionStorageKey)) || [];
    const filteredFreeGiftIds = freeGiftAdded.filter((id) => !freeGiftIds.includes(id));

    const cartItemList = document.querySelector('#CartDrawer-CartItems');
    this.toggleLoadingOverlay(cartItemList, true);

    try {
      const updates = keys.reduce((acc, key) => {
        acc[key] = 0;
        return acc;
      }, {});

      const response = await fetch('/cart/update.js', {
        body: JSON.stringify({
          updates,
          sections: ['cart-drawer', 'cart-icon-bubble']
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (response.ok) {
        sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(filteredFreeGiftIds));

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          const cartData = await response.json();
          cartDrawer.renderContents(cartData);

          this.toggleLoadingOverlay(cartItemList, false);
        }
      }
    } catch (error) {
      console.error('Error removing free gift:', error);
    }
  }

  toggleLoadingOverlay(element, show) {
    if (!element) return;
    
    if (show) {
      element.classList.add('cart__items--disabled');
    } else {
      element.classList.remove('cart__items--disabled');
    }
  }
}
const freeGiftHandler = new FreeGiftHandler();

function animateProgressBar(previousProgress = null) {
  requestAnimationFrame(() => {
    const progressLine = document.querySelector('.cart-progress-bar__line');
    if (!progressLine) return;

    const newProgress = getComputedStyle(progressLine)
      .getPropertyValue('--line-progress')
      .trim();

    const prevProgress = previousProgress || progressLine.dataset.progress || '0%';

    if (prevProgress !== newProgress) {
      progressLine.style.setProperty('--previous-progress', prevProgress);
      progressLine.dataset.progress = newProgress; 

      const progressWrapper = document.querySelector('.cart-progress-bar__wrapper');
      if (progressWrapper) {
        progressWrapper.classList.add('cart-progress-bar__wrapper--animated');
      }
    }
  });
}

// Cart Parcel Protection
function handleParcelProtectionButtons() {
  const parcelProtectionButtons = document.querySelectorAll('.cart__parcel-protection-button');
  
  parcelProtectionButtons.forEach(button => {
      button.addEventListener('click', function(event) {
          event.preventDefault();
          
          const isAdding = this.getAttribute('data-parcel-protection') === 'true';
          const variantId = this.getAttribute('data-parcel-protection-variant-id');
          
          if (isAdding) {
            if (!isProductInCart(variantId)) {
              setButtonLoadingState(button, true);
              addToCart(variantId).then(() => {
                sessionStorage.removeItem('parcelProtectionRejected');
                hideParcelProtection();
              }).catch((error) => {
                console.error('Error adding parcel protection:', error);
                setButtonLoadingState(this, false);
              });
            }
          } else {
            sessionStorage.setItem('parcelProtectionRejected', 'true');
            hideParcelProtection(); 
          }
      });
  });
}

function hideParcelProtection() {
  const parcelProtectionElement = document.querySelector('.cart__parcel-protection');
  if (!parcelProtectionElement) return;

  parcelProtectionElement.classList.add('parcel-protection-hiding');

  // Wait for transition to complete before hiding
  setTimeout(() => {
    parcelProtectionElement.classList.add('hidden');
    parcelProtectionElement.classList.remove('parcel-protection-hiding');
  }, 500); // Match the CSS transition duration
}

function shouldShowParcelProtection() {
  return !sessionStorage.getItem('parcelProtectionRejected');
}

function checkParcelProtectionState() {
  const parcelProtectionElement = document.querySelector('.cart__parcel-protection');
  if (!parcelProtectionElement) return;
  
  const variantId = parcelProtectionElement.querySelector('[data-parcel-protection-variant-id]')?.getAttribute('data-parcel-protection-variant-id');
  if (!variantId) return;
  
  parcelProtectionElement.classList.toggle('hidden', isProductInCart(variantId) || !shouldShowParcelProtection());
}
